import { useMutation } from "react-query";
import httpClient from "utils/http-client";
import { API_VERIFY } from "consts";

export default function useVerify(config) {
  return useMutation((data) => httpClient.post(API_VERIFY, data), config);
}
